module.exports = __webpack_public_path__ + "static/media/token-logo.760a5d79.png";